// Goldsky subgraph client for the 3-gen team tree (invite relations + stake
// snapshots). When the endpoint is unreachable the store falls back to reading
// RelationBound events straight from the wallet RPC.
export const INDEXER_URL = (process.env.VUE_APP_GOLDSKY_ENDPOINT || '').replace(/\/$/, '')

export async function queryIndexer(query, variables) {
  if (!INDEXER_URL) throw new Error('indexer endpoint not configured')
  const response = await fetch(INDEXER_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  })
  if (!response.ok) throw new Error(`indexer ${response.status}`)
  const payload = await response.json()
  if (payload.errors && payload.errors.length) throw new Error(payload.errors[0].message)
  return payload.data
}
